import React from "react";
import TimeAgo from "react-timeago";
import IPComponent from "./IPComponent";

const ViewLogDetails = ({ currentItem, onBack }) => {
	return (
		<>
			<div className="row">
				<div className="col-lg-6">
					<div className="card">
						<div className="card-head">
							<button
								type="button"
								className="mdl-button mdl-js-ripple-effect btn-circle btn-default"
								onClick={onBack}
							>
								<i className="material-icons">arrow_back</i>{" "}
								Back
							</button>
						</div>
						<div className="card-body  height-9">
							<div className="profile-usertitle">
								<div className="profile-usertitle-name">
									Staff
								</div>
								<div className="profile-usertitle-job">
									Detailed Staff Information
								</div>
							</div>
							<div className="row ">
								<div className="col-lg-6">
									<ul className="list-group list-group-unbordered">
										<li className="list-group-item">
											<b>First Name:</b>
											<a className="pull-right">
												{currentItem.staff.first_name}
											</a>
										</li>
										<li className="list-group-item">
											<b>Middle Name:</b>
											<a
												className={`pull-right ${
													currentItem.staff
														.middle_name
														? ""
														: "text-danger"
												}`}
											>
												{currentItem.staff.middle_name
													? currentItem.staff
															.middle_name
													: "nil"}
											</a>
										</li>
										<li className="list-group-item">
											<b>Last Name:</b>{" "}
											<a className="pull-right">Aves</a>
										</li>
										<li className="list-group-item">
											<b>Mobile No:</b>
											<a className="pull-right">
												07064646454
											</a>
										</li>
									</ul>
								</div>
								<div className="col-lg-6">
									<ul className="list-group list-group-unbordered">
										<li className="list-group-item">
											<b>Designation:</b>
											<a className="pull-right">Doctor</a>
										</li>
										<li className="list-group-item">
											<b>Department:</b>{" "}
											<a className="pull-right">
												Cutlary
											</a>
										</li>
										<li className="list-group-item">
											<b>Site:</b>
											<a className="pull-right">
												Rolfson and Sons
											</a>
										</li>
										<li className="list-group-item">
											<b>Admin Status: </b>
											<a
												className={`pull-right ${
													currentItem.staff.admin
														? ""
														: "text-danger"
												}`}
											>
												{currentItem.staff.admin
													? "Admin"
													: "Not Admin"}
											</a>
										</li>
									</ul>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div className="col-lg-6">
					<div className="card">
						<div className="card-head">
							<header>Activity Log Details</header>
						</div>
						<div className="card-body  height-9">
							<strong>Log Summary</strong>
							<div className="profile-desc">
								<code>{currentItem.summary}</code>
							</div>
							<ul className="list-group list-group-unbordered">
								<div className="row">
									<div className="col-lg-4">
										<b>IP Address: </b>
										<div className="profile-desc-item ">
											{currentItem.ip}
										</div>
									</div>
									<div className="col-lg-4">
										<b>Operation: </b>
										<div>{currentItem.activity}</div>
									</div>
									<div className="col-lg-4">
										<b>Date: </b>
										<div className="profile-desc-item">
											<TimeAgo
												date={new Date(
													parseInt(
														currentItem.datetime
													)
												).toLocaleDateString()}
											/>
										</div>
									</div>
								</div>
							</ul>
						</div>
					</div>
				</div>
			</div>
			<IPComponent _ip={currentItem.ip} />
		</>
	);
};

export default ViewLogDetails;
